<div class="breadcrumb-bar">
  <kendo-breadcrumb [items]="breadcrumbItems()"
                    (itemClick)="onItemClick($event)">
  </kendo-breadcrumb>

  <button class="k-button k-button-md k-rounded-md btn-row"
        type="button"
        (click)="logout()">
  Sign out
</button>

</div>

<router-outlet></router-outlet>
